<template>
    <CardPage :section="9" :page="73" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Great work! You’ve earned another sticker for completing this activity!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section9/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section9/complete', true);
            this.$store.set('section9/sticker@earned', true);
        }
    }
};
</script>
